import { Component, OnInit } from '@angular/core';
//Formularios
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/map'
//Alertas tipo toaster
import { ToastrService } from 'ngx-toastr';
import { empty } from 'rxjs/Observer';
//Servicios
import { ConfigService } from './../servicios/config/config.service';
import { EventosJqueryService } from './../servicios/eventos-jquery/eventos-jquery.service';
import { ValidService } from '../servicios/valid.service';
import { LoginempresaService } from '../servicios/login/loginempresa.service';

import { UsuariosService } from './../servicios/usuarios/usuarios.service';
import { KeyService } from './../servicios/key.service';
import * as CryptoJS from 'crypto-js';

//Declaracion de variable global para usar  jQuery
declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  listaingreso : any;
  usuariosArray = [];
  //Labels de la plantilla
  label_usuario         = 'Nombre del usuario';
  label_clave           = 'Clave de acceso';
  label_confirmar_clave = 'Confirmar Clave';
  label_btn_ingresar    = 'Ingresar';
  label_btn_regresar    = 'Regresar';
  label_nit             = 'Nit';

  //Variables
  usuario_usuarioid   : string;
  usuario_clave       : string;
  mostrarDatos        : boolean;
  mostrarLoginEmpresa : boolean = true;
  mostrarLogin        : boolean = false;
  PATH                : any;
  ACCESOS_PRO         = [];
  formLoginEmpresa    : FormGroup;
  formLoginUsuario    : FormGroup;

  //Objetos que contienen las variables para los campos de los formularios
  loginempresa = { nit : '' }
  loginusuario = { usuarioid : '', clave : '', clave_confirmar : '' }

  datos_conexion : any;

  //Variables para verificar que un cliente esta logueado
  useringresoid     : any;
  useringresoestado : any;
  prevValue = 0;
  val = [];

  public loading = true;


  constructor(
    private route     : ActivatedRoute,
    private router    : Router,
    private http      : Http,
    private toastr    : ToastrService,
    private _config   : ConfigService,
    private _evtjq    : EventosJqueryService,
    private _valid    : ValidService,
    private _Login    : LoginempresaService,
    private _key      : KeyService
  ) {}


  ngOnInit()
  {
    //Escucha los eventos al presionar la tecla Enter
    this._evtjq.eventoTeclaEnter();

    //Formulario de creación
    this.createForm();
  }

  encryptData(data,key) {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Permite enviar el nit de la empresa para entrar a la aplicación
   * JMM-2019-02-28
   */
  getEmpresa()
  {
    //Si validacion erronea del formulario muestra mensaje
    if (!this.formLoginEmpresa.valid) {
      this._valid.touched(this.formLoginEmpresa);
      this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
    } else {
      this._Login.getEmpresa(this.formLoginEmpresa.value.nit).subscribe((resp) => {
        if (resp.data) {
          this.mostrarLogin = true;
          this.mostrarLoginEmpresa = false;
          this.datos_conexion = resp.data;
          this.mostrarDatos = false;

          this.getUsuarioActivos();
          $('.AccesoFinal').removeClass('AccesoFinal').addClass('AccesoUser');
        } else {
          this.toastr.error('Verifique los datos ingresados.', 'Error', { timeOut: 3000 });
        }
      });
    }
  }// .getEmpresa()

  getUsuarioActivos(){

     this.PATH = this._config.obtenerPath();
    //  let url = this.PATH+'/api/admin/getUsuarioActivos';
    //  this.ACCESOS_PRO = this._config.accesosPro();

     this._Login.getUsuarioActivos(this.datos_conexion).subscribe((data) => {
      // this.http.post(url,{data : this.datos_conexion}, {headers:this._key.head()}).map(resp => resp.json()).subscribe(data => {
        this.usuariosArray = data.data.datoslogin.usuarios;
        this.listaingreso  = data.data.datoslogin.montaje;

        if(this.listaingreso == '1'){
          setTimeout(() => {
              setTimeout(() => {
                  $('.chos-unit select[unitario]').chosen({
                    placeholder_text_single: 'Seleccione Opción'
                    ,width: '100%'
                    ,no_results_text: 'Ooops, no se encuentra'
                    ,allow_single_deselected: true
                });
              },0);
          });
        }
      });
  }


  /**
   * Permite retornar
   * JMM-2019-02-28
   */
  retornar()
  {
    this.mostrarLogin = false;
    this.mostrarLoginEmpresa = true;
    $('.AccesoUser').removeClass('AccesoUser').addClass('AccesoFinal');
  }// .retornar()


  /**
   * Permite el logueo para entrar al sistema
   * JMM-2018-03-15
   */
  login(form: NgForm)
  {
    // this.mostrarDatos = false;

    if($("#usuarioid").val() != null){
      form.value.usuarioid = this.listaingreso =='1' ? $("#usuarioid").val() :$("#usuarioid").val();
    }
    //Obtener la ruta de conexion global
    this.PATH = this._config.obtenerPath();
    let url = this.PATH+'/api/login';

    let data = {
      'usuarioid'         : form.value.usuarioid,
      'clave'             : form.value.clave,
      'validacambioclave' : this.mostrarDatos,
      'clave_confirm'     : form.value.clave_confirmar,
      'datos_conexion'    : this.datos_conexion
    };
    //Conexion a base de datos
    localStorage.setItem('prosof', JSON.stringify(this.datos_conexion.prosof));

    this.ACCESOS_PRO = this._config.accesosPro();

    //Validacion para los campos obligatorios
    if (data.usuarioid != "" && data.clave.length != "")
    {
      //Validacion para la longitud del contenido de los campos
      if (data.usuarioid.length >= 1 && data.clave.length >= 1)
      {

        this.http.post(url, data, {headers:this._key.head()}).map(resp => resp.json()).subscribe(data => {
          this.useringresoid = data.data.useringresoid;
          this.useringresoestado = data.data.useringresoestado;

          //Si el numero de usuarios conectados es mayor al numero de usuarios licenciados
          if (data.data.msj_errornumusulic == "msj_errornumusulic")
          {
            this.toastr.warning('Su empresa solo tiene licencia para: '+data.data.numusulic+' usuarios', 'Advertencia', {
              timeOut: 3000,
            });
          }

          //Si la clave de confirmación no coincide
          if (data.data == "msj_claveconfirm")
          {
            this.toastr.error('Clave no coincide', 'Error', {
              timeOut: 3000,
            });
          }




          //Si debe confirmar la clave
          if (data.error === true && data.message == 'confirme_clave_vencida')
          {
            this.toastr.warning('La clave se ha vencido, por favor cambie la clave nuevamente', '', {
              timeOut: 3000,
            });
            this.mostrarDatos = true;
          }


          //Si debe confirmar la clave
          if (data.error === true && data.message == 'confirme_clave')
          {
            this.toastr.warning('Confirme clave', '', {
              timeOut: 3000,
            });
            this.mostrarDatos = true;
          }

          //Si registro no existe muestra mensaje
          if (data.error === true && data.data == "")
          {
            this.toastr.error('Verifique que el usuario y la contraseña sean correctos', 'Error', {
              timeOut: 3000
            });
          }

          //En caso que el usuario exista pero no tenga clave
          if (data.error === true && data.data.length > 0)
          {

            let data = {
              'usuarioid'         : form.value.usuarioid.toUpperCase(),
              'clave'             : form.value.clave,
              'validacambioclave' : this.mostrarDatos,
              'clave_confirm'     : form.value.clave_confirmar
            };

            //Si no se confirma la clave muestra mensaje
            if (data.clave_confirm == "")
            {
              this.toastr.warning('Confirmar clave', '', {
                timeOut: 3000,
              });
            }//Fin de if (data.clave_confirm == "")

            //Validacion para comparar la clave de acceso
            if (data.clave == data.clave_confirm)
            {
              this.http.post(url, data).map(resp => resp.json()).subscribe(data => {

                //Si existe un error yel estado del usuario es inactivo muestra mensaje de error
                if (data.error == true) {
                  this.toastr.error(data.message, 'Error', {
                    timeOut: 3000,
                  });
                }//Fin de if (data.error == false)
                else {
                  this.toastr.success('Acceso permitido '+data.data.usuarioid+'', '', {
                    timeOut: 3000,
                  });

                  localStorage.setItem('idusuario',data.data.id);
                  localStorage.setItem('PATH',this._config.obtenerPath());
                  localStorage.setItem('usuarioid',data.data.usuarioid);
                  localStorage.setItem('clave', data.data.clave);
                  localStorage.setItem('nombreUsuario', data.data.nombre);
                  localStorage.setItem('cedulaUsuario',data.data.cedula);
                  localStorage.setItem('idperfil', data.data.perfilid);
                  localStorage.setItem('tipousuario', data.data.tipousuario);
                  localStorage.setItem('logout', 'logout'); //Parametro que se usa una sola vez al momento de loguearse
                  localStorage.setItem('nombreEmpresa', this.datos_conexion.Nombre);
                  localStorage.setItem('nitEmpresa', this.datos_conexion.Nit);
                  localStorage.setItem('useringresoid', this.useringresoid);
                  localStorage.setItem('useringresoestado', this.useringresoestado);
                  localStorage.setItem('sucursalcliente', data.data.sucursalcliente);
                  localStorage.setItem('proximafecha', data.data.proximafecha);

                  this.router.navigate(['main/dashboard'], { replaceUrl: true });
                  location.reload();
                }//Fin de else
              });
            }//Fin de if (data.clave == data.clave_confirmar)
            else if (data.clave_confirm)
            {
              this.toastr.error('La clave no coincide', 'Error', {
                timeOut: 3000,
              });
            }//Fin de else if (data.clave_confirmar)
          }//Fin de if (data.error === true && data.data.length > 0)

          //Validacion en caso que la clave de usuario exista y el usuario este activo
          if (data.error === false && data.data.estado == 'A')
          {
            this.toastr.success('Acceso permitido '+data.data.usuarioid+'', '', {
              timeOut: 3000,
            });

            localStorage.setItem('PATH',this._config.obtenerPath());
            localStorage.setItem('idusuario',data.data.id);
            localStorage.setItem('usuarioid',data.data.usuarioid);
            localStorage.setItem('clave', data.data.clave);
            localStorage.setItem('nombreUsuario', data.data.nombre);
            localStorage.setItem('cedulaUsuario',data.data.cedula);
            localStorage.setItem('idperfil', data.data.perfilid);
            localStorage.setItem('tipousuario', data.data.tipousuario);
            localStorage.setItem('logout', 'logout'); //Parametro que se usa una sola vez al momento de loguearse
            localStorage.setItem('nombreEmpresa', this.datos_conexion.Nombre);
            localStorage.setItem('nitEmpresa', this.datos_conexion.Nit);
            localStorage.setItem('useringresoid', this.useringresoid);
            localStorage.setItem('useringresoestado', this.useringresoestado);
            localStorage.setItem('sucursalcliente', data.data.sucursalcliente);
            localStorage.setItem('proximafecha', data.data.proximafecha);

            this.router.navigate(['/main/dashboard'], { replaceUrl: true });
            location.reload();
          }//Fin de if (data.error === false)
          else if (data.error === false && data.data.estado == 'I')
          {
            this.toastr.error('Error al acceder. Usuario inactivo.', 'Error', {
              timeOut: 3000,
            });
          }// .else if (data.error === false && data.data.estado == 'I')

        });

      }//Fin de if (data.usuarioid.length >= 6 && data.clave.length >= 6)
      else
      {
        this.toastr.error('Los datos de acceso no deben tener menos de 6 caracteres', 'Error', {
          timeOut: 3000,
        });
      }// Fin de else
    }//Fin de  if (data.usuarioid != "" || data.clave.length != "")
    else
    {
      this.toastr.error('Campos obligatorios', 'Error', {
        timeOut: 3000,
      });
    }//Fin de else

  }//Fin de login(form: NgForm)


  /**
   * Permite validar el formulario
   * JMM-2019-02-28
   */
  createForm()
  {
    this.formLoginEmpresa = new FormGroup({
      'nit' : new FormControl(this.loginempresa.nit, [Validators.required])
    });

    this.formLoginUsuario = new FormGroup({
      'familiaid'       : new FormControl(this.loginusuario.usuarioid, [Validators.required]),
      'clave'           : new FormControl(this.loginusuario.clave, [Validators.required]),
      'clave_confirmar' : new FormControl(this.loginusuario.clave_confirmar, [Validators.required])
    });
  }// .createForm()

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/login/login.component.ts